<template>
  <w-sliding-popup ref="slidingPopup" type="setting" :title="popupTitle" @close="closePopup" width="500px">
    <el-form slot="content" :ref="formName" :model="groupSettingInfo" :rules="rules" label-position="top">
      <el-row v-if="currentTreeType === 'keyTrs'">
        <el-col :span="24">
          <el-form-item label="비즈니스 이름" prop="bizName">
            <el-input v-model="groupSettingInfo.bizName" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="24">
          <el-form-item label="티어 이름" prop="tierName">
            <el-input v-model="groupSettingInfo.tierName" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button size="large" type="solid" @click="saveGroupInfo">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';

const tierType = { application: 'APPLICATION', instance: 'INSTANCE' };
const treetype = { keyTrs: '비즈니스', application: '티어', instance: '티어' };

export default {
  name: 'WGroupSettingPopup',
  props: {
    currentTreeType: {
      type: String,
    },
    popupOpenNode: {
      type: Object,
    },
  },
  data() {
    return {
      formName: 'groupSettingForm',
      popupTitle: '그룹 정보 추가/변경',
      groupSettingInfo: {
        bizId: null,
        bizName: null,
        tierId: null,
        tierName: null,
      },
      rules: {
        bizName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
        tierName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
    };
  },
  methods: {
    initModel() {
      this.groupSettingInfo.bizId = null;
      this.groupSettingInfo.bizName = '';
      this.groupSettingInfo.tierId = null;
      this.groupSettingInfo.tierName = '';
    },
    closePopup() {
      this.initModel();
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open(node) {
      this.$refs.slidingPopup.open();
      if (!isNil(node)) {
        this.popupType = node.popupType;
        if (node.popupType === 'MODIFY') {
          this.popupTitle = `${treetype[this.currentTreeType]} 수정`;
          switch (this.currentTreeType) {
            case 'keyTrs':
              this.groupSettingInfo.bizName = node.bizName;
              this.groupSettingInfo.bizId = node.bizId;
              break;
            default:
              this.groupSettingInfo.tierName = node.tierName;
              this.groupSettingInfo.tierId = node.tierId;
              break;
          }
        } else {
          this.popupTitle = `${treetype[this.currentTreeType]} 추가`;
          this.initModel();
        }
      }
      this.$emit('open');
    },
    saveGroupInfo() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          if (this.popupType === 'ADD') {
            // 도메인 추가 URL 호출
            switch (this.currentTreeType) {
              case 'keyTrs':
                this.saveBiz();
                break;
              default:
                this.saveTier();
                break;
            }
          } else {
            // 도메인 수정 URL 호출
            switch (this.currentTreeType) {
              case 'keyTrs':
                this.updateBiz();
                break;
              default:
                this.updateTier();
                break;
            }
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주세요.'));
        }
      });
    },
    saveTier() {
      /*
       어플리케이션 / 인스턴스에 따라서 값이 저장
      */
      const me = this;
      const tierTypeName = tierType[this.currentTreeType];
      const parmas = {
        domainId: this.popupOpenNode.data.domainId,
        tierType: tierTypeName,
        tierName: this.groupSettingInfo.tierName,
      };
      me.$refs[me.formName].validate((valid) => {
        if (valid) {
          ApmSettingAPI.insertTier(parmas).then((response) => {
            if (response.data.success) {
              this.$emit('reload');
              this.closePopup();
            }
          });
        }
      });
    },
    saveBiz() {
      const me = this;
      const parmas = {
        domainId: this.popupOpenNode.data.domainId,
        bizName: this.groupSettingInfo.bizName,
      };
      me.$refs[me.formName].validate((valid) => {
        if (valid) {
          ApmSettingAPI.insertApmBiz(parmas).then((response) => {
            if (response.data.success) {
              this.$emit('reload');
              this.closePopup();
            }
          });
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주세요.'));
        }
      });
    },
    updateBiz() {
      const me = this;
      const parmas = {
        domainId: this.popupOpenNode.data.domainId,
        bizName: this.groupSettingInfo.bizName,
        bizId: this.groupSettingInfo.bizId,
      };
      me.$refs[me.formName].validate((valid) => {
        if (valid) {
          ApmSettingAPI.updateApmBiz(parmas).then((response) => {
            if (response.data.success) {
              this.$emit('reload');
              this.closePopup();
            }
          });
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주세요.'));
        }
      });
    },
    updateTier() {
      const me = this;
      const parmas = {
        domainId: this.popupOpenNode.data.domainId,
        tierName: this.groupSettingInfo.tierName,
        tierId: this.groupSettingInfo.tierId,
      };
      me.$refs[me.formName].validate((valid) => {
        if (valid) {
          ApmSettingAPI.updateTier(parmas).then((response) => {
            if (response.data.success) {
              this.$emit('reload');
              this.closePopup();
            }
          });
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주세요.'));
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/common/popup/GroupSettingPopup.vue